export enum FormSelectionMode {
    RADIO_BUTTON = 'RADIO_BUTTON',
    SELECTION = 'SELECTION',
    CHECKBOX = 'CHECKBOX',
    SELECTION_KEY_VALUE = 'SELECTION_KEY_VALUE',
    TAGS = 'TAGS',
    MAT_SELECTION = 'MAT_SELECTION'
}